import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import useTrans from '@hooks/useTrans'
import { cn, getUserType } from '@utils/safeTs'
import { OrdineDetailType, PersonalizzazioneOrdineType, RootStateType, UserType } from '@utils/types'
import { MyAccountOrdineSectionHead } from '@components/atoms'
import styles from './FlussoPersonalizzazionePersonalizzazione.module.sass'
import { getStatoPersonalizzazione } from '@utils/gestione/utils'
import { MyAccountArticoliOrdine, MyAccountPersonalizzazioneHead } from '@components/molecules'


interface Props {
  ordine?: OrdineDetailType
  personalizzazione: PersonalizzazioneOrdineType
  personalizzazioniOpen: number[]
  setPersonalizzazioniOpen: React.Dispatch<React.SetStateAction<number[]>>
  variant?: '' | 'caricamento-bozze'
  userType: UserType
  children?: React.ReactNode
  className?: string
}

const FlussoPersonalizzazionePersonalizzazione = (props: Props) => {

  const { 
    ordine,
    personalizzazione,
    personalizzazioniOpen,
    setPersonalizzazioniOpen,
    variant = '',
    userType,
    children,
    className = '',
  } = props

  const t = useTrans()

  const statoPersonalizzazione = useMemo(() => getStatoPersonalizzazione(personalizzazione, ordine), [personalizzazione.posizioniPersonalizzazioneOrdine])

  return (
    <div id={`personalizzazione_${personalizzazione.id}`} className={cn(styles.root, personalizzazioniOpen.includes(personalizzazione.id) ? styles['root--open'] : '', className)}>
      <MyAccountPersonalizzazioneHead 
        id={`personalizzazionehead_${personalizzazione.id}`}
        contentId={`personalizzazioneaccordionbody_${personalizzazione.id}`}
        ordine={ordine}
        personalizzazione={{...personalizzazione, statoPersonalizzazione: statoPersonalizzazione }}
        variant="accordion"
        userType={userType}
        open={personalizzazioniOpen.includes(personalizzazione.id)}
        setOpen={(v) => setPersonalizzazioniOpen(prev => prev.filter(p => p !== personalizzazione.id).concat(v ? [personalizzazione.id] : []))}
      />
      <div className={styles.body} 
        role="region"
        id={`personalizzazioneaccordionbody_${personalizzazione.id}`}
        aria-labelledby={`personalizzazionehead_${personalizzazione.id}`}
      >
        <MyAccountArticoliOrdine 
          righeOrdine={personalizzazione.righeOrdine}
          note={variant === 'caricamento-bozze'}
          noteStyle={'accent'}
          userType={userType}
          collapsible
        />
        <div className={styles.posizioni}>
          <div className={styles.posizioniBody}>
            {children}
          </div>
        </div>
      </div>

    </div>
  )
}

export default FlussoPersonalizzazionePersonalizzazione
